var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"active":this.$store.state.vueLoad,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){return _vm.$set(this.$store.state, "vueLoad", $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }